import { render } from "./OperationalTasks.vue?vue&type=template&id=463fc028&scoped=true"
import script from "./OperationalTasks.vue?vue&type=script&lang=js"
export * from "./OperationalTasks.vue?vue&type=script&lang=js"

import "./OperationalTasks.vue?vue&type=style&index=0&id=463fc028&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-463fc028"]])

export default __exports__